import { createAction } from 'redux-actions';

export const addUpdateUserImage = createAction('ADD_UPDATE_USER_IMAGE');

export default {
  addUpdateUserImage,
};
